var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPushmessage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.9 29.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.76192271,0,0,0.79368704,3.8001621,2.8471183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.952,
    cy: 14.949,
    r: 3.092,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 14.951,0 C 6.694,0 0.004,6.691 0.002,14.949 0.004,23.207 6.694,29.896 14.952,29.9 23.208,29.896 29.897,23.207 29.899,14.949 29.896,6.691 23.208,0 14.951,0 Z m 8.793,23.738 C 21.48,25.994 18.392,27.379 14.951,27.383 11.508,27.379 8.419,25.994 6.159,23.738 3.905,21.48 2.52,18.392 2.517,14.949 2.52,11.508 3.905,8.418 6.159,6.156 c 2.26,-2.252 5.348,-3.641 8.792,-3.641 3.441,0 6.529,1.389 8.793,3.641 2.254,2.262 3.639,5.352 3.641,8.793 -0.003,3.444 -1.386,6.531 -3.641,8.789 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m 14.951,5.152 c -5.256,0 -9.514,4.262 -9.517,9.518 0.003,5.26 4.261,9.516 9.517,9.52 5.258,-0.004 9.516,-4.26 9.52,-9.52 -0.005,-5.256 -4.262,-9.518 -9.52,-9.518 z m 5.002,14.52 c -1.285,1.283 -3.043,2.07 -5.002,2.074 -1.957,-0.004 -3.715,-0.791 -5,-2.074 -1.285,-1.285 -2.07,-3.041 -2.072,-5.002 0.002,-1.957 0.787,-3.715 2.072,-5.002 1.286,-1.281 3.043,-2.072 5,-2.072 1.959,0 3.717,0.791 5.002,2.072 1.285,1.287 2.072,3.045 2.074,5.002 -0.001,1.961 -0.789,3.717 -2.074,5.002 z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPushmessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pushmessage.f3ce47c8321d20b78a830cce8699fd14.svg";